// // ============================================================
// // src/components/Navbar.js
// // ============================================================
// import React, { useState } from "react";
// import { useHospital } from "../context/HospitalContext";

// export default function Navbar({ onAdminClick }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const { hospital } = useHospital();

//   const scrollTo = (id) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
//     setMobileOpen(false);
//   };

//   return (
//     <>
//       <nav>
//         <a className="nav-logo" onClick={() => scrollTo("home")}>
//           <div className="logo-icon">
//             {hospital.logoUrl ? (
//               <img
//                 src={hospital.logoUrl}
//                 alt={hospital.name}
//                 style={{
//                   width: 36,
//                   height: 36,
//                   borderRadius: "50%",
//                   objectFit: "cover",
//                 }}
//               />
//             ) : (
//               "🦷"
//             )}
//           </div>
//           <div>
//             <div className="logo-text">
//               {/* Show first word of hospital name as logo text */}
//               {hospital.name.split(" ")[0]}
//             </div>
//             <div className="logo-sub">{hospital.tagline}</div>
//           </div>
//         </a>
//         <ul className="nav-links">
//           <li>
//             <a onClick={() => scrollTo("services")}>Services</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("pricing")}>Pricing</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("about")}>About</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("doctors")}>Doctors</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("testimonials")}>Reviews</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("faq")}>FAQ</a>
//           </li>
//           <li>
//             <a
//               onClick={onAdminClick}
//               style={{ color: "var(--gold)", fontWeight: 500 }}
//             >
//               Doctor Admin Panel
//             </a>
//           </li>
//           <li>
//             <a className="nav-cta" onClick={() => scrollTo("appointment")}>
//               Book Appointment
//             </a>
//           </li>
//         </ul>
//         <button
//           className="hamburger"
//           onClick={() => setMobileOpen(!mobileOpen)}
//         >
//           <span />
//           <span />
//           <span />
//         </button>
//       </nav>

//       <div className={`mobile-nav${mobileOpen ? " open" : ""}`}>
//         <a onClick={() => scrollTo("services")}>Services</a>
//         <a onClick={() => scrollTo("pricing")}>Pricing</a>
//         <a onClick={() => scrollTo("about")}>About</a>
//         <a onClick={() => scrollTo("doctors")}>Our Doctors</a>
//         <a onClick={() => scrollTo("gallery")}>Clinic</a>
//         <a onClick={() => scrollTo("testimonials")}>Reviews</a>
//         <a onClick={() => scrollTo("faq")}>FAQ</a>
//         <a
//           onClick={() => {
//             setMobileOpen(false);
//             onAdminClick();
//           }}
//           style={{ color: "var(--gold)", fontWeight: 500 }}
//         >
//           Doctor Admin Panel
//         </a>
//         <a
//           onClick={() => scrollTo("appointment")}
//           style={{ color: "var(--teal-light)", fontWeight: 500 }}
//         >
//           Book Appointment →
//         </a>
//       </div>
//     </>
//   );
// }

// // ============================================================
// // src/components/Navbar.js
// // ✅ Specialty text wired via getSpecialtyText()
// // ============================================================
// import React, { useState } from "react";
// import { useHospital } from "../context/HospitalContext";
// import { getSpecialtyText } from "../utils/specialtyText";

// export default function Navbar({ onAdminClick }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const { hospital } = useHospital();
//   const t = getSpecialtyText(hospital.type);

//   const scrollTo = (id) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
//     setMobileOpen(false);
//   };

//   return (
//     <>
//       <nav>
//         <a className="nav-logo" onClick={() => scrollTo("home")}>
//           <div className="logo-icon">
//             {hospital.logoUrl ? (
//               <img
//                 src={hospital.logoUrl}
//                 alt={hospital.name}
//                 style={{
//                   width: 36,
//                   height: 36,
//                   borderRadius: "50%",
//                   objectFit: "cover",
//                 }}
//               />
//             ) : (
//               "🦷"
//             )}
//           </div>
//           <div>
//             <div className="logo-text">{hospital.name.split(" ")[0]}</div>
//             <div className="logo-sub">{t.navTagline}</div>
//           </div>
//         </a>

//         <ul className="nav-links">
//           <li>
//             <a onClick={() => scrollTo("services")}>{t.navServices}</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("pricing")}>{t.navTreatments}</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("about")}>About</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("doctors")}>{t.navDoctors}</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("testimonials")}>Reviews</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("faq")}>FAQ</a>
//           </li>
//           <li>
//             <a
//               onClick={onAdminClick}
//               style={{ color: "var(--gold)", fontWeight: 500 }}
//             >
//               Doctor Admin Panel
//             </a>
//           </li>
//           <li>
//             <a className="nav-cta" onClick={() => scrollTo("appointment")}>
//               {t.navBook}
//             </a>
//           </li>
//         </ul>

//         <button
//           className="hamburger"
//           onClick={() => setMobileOpen(!mobileOpen)}
//         >
//           <span />
//           <span />
//           <span />
//         </button>
//       </nav>

//       <div className={`mobile-nav${mobileOpen ? " open" : ""}`}>
//         <a onClick={() => scrollTo("services")}>{t.navServices}</a>
//         <a onClick={() => scrollTo("pricing")}>{t.navTreatments}</a>
//         <a onClick={() => scrollTo("about")}>About</a>
//         <a onClick={() => scrollTo("doctors")}>{t.navDoctors}</a>
//         <a onClick={() => scrollTo("gallery")}>Gallery</a>
//         <a onClick={() => scrollTo("testimonials")}>Reviews</a>
//         <a onClick={() => scrollTo("faq")}>FAQ</a>
//         <a
//           onClick={() => {
//             setMobileOpen(false);
//             onAdminClick();
//           }}
//           style={{ color: "var(--gold)", fontWeight: 500 }}
//         >
//           Doctor Admin Panel
//         </a>
//         <a
//           onClick={() => scrollTo("appointment")}
//           style={{ color: "var(--teal-light)", fontWeight: 500 }}
//         >
//           {t.navBook} →
//         </a>
//       </div>
//     </>
//   );
// }

//////////////////// above is correct just css testing is below ////////////
// // ============================================================
// // src/components/Navbar.js
// // ✅ Specialty text wired via getSpecialtyText()
// // ✅ Fully responsive for mobile, tablet, laptop, desktop
// // ============================================================
// import React, { useState } from "react";
// import { useHospital } from "../context/HospitalContext";
// import { getSpecialtyText } from "../utils/specialtyText";

// const navStyles = `
//   /* ─── Base Nav ─────────────────────────────────────────────── */
//   nav {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     padding: 0 24px;
//     height: 72px;
//     background: var(--dark, #0f172a);
//     position: sticky;
//     top: 0;
//     z-index: 1000;
//     box-sizing: border-box;
//     width: 100%;
//     gap: 12px;
//   }

//   /* ─── Logo ──────────────────────────────────────────────────── */
//   .nav-logo {
//     display: flex;
//     align-items: center;
//     gap: 10px;
//     cursor: pointer;
//     flex-shrink: 0;
//     text-decoration: none;
//   }

//   .logo-icon {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     width: 42px;
//     height: 42px;
//     flex-shrink: 0;
//   }

//   .logo-text {
//     font-size: 1.15rem;
//     font-weight: 700;
//     color: #fff;
//     line-height: 1.2;
//     white-space: nowrap;
//   }

//   .logo-sub {
//     font-size: 0.65rem;
//     font-weight: 600;
//     letter-spacing: 0.08em;
//     color: var(--gold, #d4a853);
//     text-transform: uppercase;
//     white-space: nowrap;
//   }

//   /* ─── Desktop Nav Links ─────────────────────────────────────── */
//   .nav-links {
//     display: flex;
//     align-items: center;
//     gap: 0;
//     list-style: none;
//     margin: 0;
//     padding: 0;
//     flex: 1;
//     justify-content: flex-end;
//     flex-wrap: nowrap;
//     overflow: hidden;
//   }

//   .nav-links li {
//     flex-shrink: 1;
//   }

//   .nav-links li a {
//     display: block;
//     padding: 8px 10px;
//     color: rgba(255, 255, 255, 0.82);
//     font-size: 0.83rem;
//     font-weight: 400;
//     cursor: pointer;
//     white-space: nowrap;
//     text-decoration: none;
//     transition: color 0.15s;
//     line-height: 1.3;
//   }

//   .nav-links li a:hover {
//     color: #fff;
//   }

//   /* CTA button */
//   .nav-links .nav-cta {
//     display: inline-block;
//     margin-left: 8px;
//     padding: 9px 16px !important;
//     background: var(--teal, #0d9488);
//     color: #fff !important;
//     border-radius: 8px;
//     font-weight: 600 !important;
//     font-size: 0.82rem !important;
//     white-space: nowrap;
//     transition: background 0.18s, opacity 0.18s;
//   }

//   .nav-links .nav-cta:hover {
//     background: var(--teal-dark, #0f766e);
//     color: #fff !important;
//   }

//   /* ─── Hamburger (hidden on desktop) ────────────────────────── */
//   .hamburger {
//     display: none;
//     flex-direction: column;
//     justify-content: center;
//     align-items: center;
//     gap: 5px;
//     width: 40px;
//     height: 40px;
//     background: transparent;
//     border: 1.5px solid rgba(255,255,255,0.25);
//     border-radius: 8px;
//     cursor: pointer;
//     flex-shrink: 0;
//     padding: 0;
//   }

//   .hamburger span {
//     display: block;
//     width: 20px;
//     height: 2px;
//     background: #fff;
//     border-radius: 2px;
//     transition: transform 0.2s, opacity 0.2s;
//   }

//   /* ─── Mobile Nav Drawer ─────────────────────────────────────── */
//   .mobile-nav {
//     display: none;
//     flex-direction: column;
//     background: var(--dark, #0f172a);
//     padding: 0;
//     max-height: 0;
//     overflow: hidden;
//     transition: max-height 0.3s ease, padding 0.3s ease;
//     border-top: 1px solid rgba(255,255,255,0.08);
//     position: fixed;
//     top: 64px;
//     left: 0;
//     right: 0;
//     z-index: 998;
//     box-shadow: 0 8px 24px rgba(0,0,0,0.4);
//   }

//   @media (max-width: 480px) {
//     .mobile-nav {
//       top: 58px;
//     }
//   }

//   .mobile-nav.open {
//     max-height: 600px;
//     padding: 8px 0 16px;
//   }

//   .mobile-nav a {
//     display: block;
//     padding: 13px 24px;
//     color: rgba(255, 255, 255, 0.82);
//     font-size: 0.95rem;
//     font-weight: 400;
//     cursor: pointer;
//     text-decoration: none;
//     border-bottom: 1px solid rgba(255,255,255,0.05);
//     transition: background 0.15s, color 0.15s;
//   }

//   .mobile-nav a:hover {
//     background: rgba(255,255,255,0.05);
//     color: #fff;
//   }

//   .mobile-nav a:last-child {
//     border-bottom: none;
//   }

//   /* ─── Large Desktop (≥ 1440px) ─────────────────────────────── */
//   @media (min-width: 1440px) {
//     nav {
//       padding: 0 48px;
//     }

//     .nav-links li a {
//       font-size: 0.88rem;
//       padding: 8px 13px;
//     }

//     .nav-links .nav-cta {
//       padding: 9px 20px !important;
//       font-size: 0.88rem !important;
//     }
//   }

//   /* ─── Standard Desktop (1024px – 1439px) ───────────────────── */
//   @media (min-width: 1024px) and (max-width: 1439px) {
//     nav {
//       padding: 0 24px;
//     }

//     .nav-links li a {
//       font-size: 0.82rem;
//       padding: 8px 9px;
//     }

//     .nav-links .nav-cta {
//       padding: 8px 14px !important;
//       font-size: 0.81rem !important;
//       margin-left: 6px;
//     }
//   }

//   /* ─── Laptop / Small Desktop (900px – 1023px) ──────────────── */
//   @media (min-width: 900px) and (max-width: 1023px) {
//     nav {
//       padding: 0 16px;
//       gap: 6px;
//     }

//     .logo-text {
//       font-size: 1rem;
//     }

//     .logo-sub {
//       font-size: 0.6rem;
//     }

//     .nav-links li a {
//       font-size: 0.76rem;
//       padding: 7px 7px;
//     }

//     .nav-links .nav-cta {
//       padding: 7px 11px !important;
//       font-size: 0.76rem !important;
//       margin-left: 4px;
//     }
//   }

//   /* ─── Tablet (768px – 899px): switch to hamburger ──────────── */
//   @media (max-width: 899px) {
//     .nav-links {
//       display: none;
//     }

//     .hamburger {
//       display: flex;
//     }

//     .mobile-nav {
//       display: flex;
//     }

//     nav {
//       height: 64px;
//       padding: 0 16px;
//     }
//   }

//   /* ─── Mobile (≤ 480px) ─────────────────────────────────────── */
//   @media (max-width: 480px) {
//     nav {
//       height: 58px;
//       padding: 0 14px;
//     }

//     .logo-icon {
//       width: 34px;
//       height: 34px;
//     }

//     .logo-icon img {
//       width: 34px !important;
//       height: 34px !important;
//     }

//     .logo-text {
//       font-size: 0.95rem;
//     }

//     .logo-sub {
//       font-size: 0.58rem;
//     }

//     .mobile-nav a {
//       font-size: 0.9rem;
//       padding: 12px 16px;
//     }
//   }
// `;

// export default function Navbar({ onAdminClick }) {
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const { hospital } = useHospital();
//   const t = getSpecialtyText(hospital.type);

//   const scrollTo = (id) => {
//     document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
//     setMobileOpen(false);
//   };

//   return (
//     <>
//       <style>{navStyles}</style>

//       <nav>
//         <a className="nav-logo" onClick={() => scrollTo("home")}>
//           <div className="logo-icon">
//             {hospital.logoUrl ? (
//               <img
//                 src={hospital.logoUrl}
//                 alt={hospital.name}
//                 style={{
//                   width: 36,
//                   height: 36,
//                   borderRadius: "50%",
//                   objectFit: "cover",
//                 }}
//               />
//             ) : (
//               "🦷"
//             )}
//           </div>
//           <div>
//             <div className="logo-text">{hospital.name.split(" ")[0]}</div>
//             <div className="logo-sub">{t.navTagline}</div>
//           </div>
//         </a>

//         <ul className="nav-links">
//           <li>
//             <a onClick={() => scrollTo("services")}>{t.navServices}</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("pricing")}>{t.navTreatments}</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("about")}>About</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("doctors")}>{t.navDoctors}</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("testimonials")}>Reviews</a>
//           </li>
//           <li>
//             <a onClick={() => scrollTo("faq")}>FAQ</a>
//           </li>
//           <li>
//             <a
//               onClick={onAdminClick}
//               style={{ color: "var(--gold)", fontWeight: 500 }}
//             >
//               Doctor Admin Panel
//             </a>
//           </li>
//           <li>
//             <a className="nav-cta" onClick={() => scrollTo("appointment")}>
//               {t.navBook}
//             </a>
//           </li>
//         </ul>

//         <button
//           className="hamburger"
//           onClick={() => setMobileOpen(!mobileOpen)}
//           aria-label="Toggle navigation menu"
//         >
//           <span />
//           <span />
//           <span />
//         </button>
//       </nav>

//       <div className={`mobile-nav${mobileOpen ? " open" : ""}`}>
//         <a onClick={() => scrollTo("services")}>{t.navServices}</a>
//         <a onClick={() => scrollTo("pricing")}>{t.navTreatments}</a>
//         <a onClick={() => scrollTo("about")}>About</a>
//         <a onClick={() => scrollTo("doctors")}>{t.navDoctors}</a>
//         <a onClick={() => scrollTo("gallery")}>Gallery</a>
//         <a onClick={() => scrollTo("testimonials")}>Reviews</a>
//         <a onClick={() => scrollTo("faq")}>FAQ</a>
//         <a
//           onClick={() => {
//             setMobileOpen(false);
//             onAdminClick();
//           }}
//           style={{ color: "var(--gold)", fontWeight: 500 }}
//         >
//           Doctor Admin Panel
//         </a>
//         <a
//           onClick={() => scrollTo("appointment")}
//           style={{ color: "var(--teal-light)", fontWeight: 500 }}
//         >
//           {t.navBook} →
//         </a>
//       </div>
//     </>
//   );
// }

//// mobile css

// ============================================================
// src/components/Navbar.js
// ✅ Specialty text wired via getSpecialtyText()
// ✅ Fully responsive for mobile, tablet, laptop, desktop
// ✅ FIXED: Mobile/tablet logo and navbar 2x bigger
// ============================================================
import React, { useState } from "react";
import { useHospital } from "../context/HospitalContext";
import { getSpecialtyText } from "../utils/specialtyText";

const navStyles = `
  /* ─── Base Nav ─────────────────────────────────────────────── */
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
    height: 72px;
    background: var(--dark, #0f172a);
    position: sticky;
    top: 0;
    z-index: 1000;
    box-sizing: border-box;
    width: 100%;
    gap: 12px;
  }

  /* ─── Logo ──────────────────────────────────────────────────── */
  .nav-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    flex-shrink: 0;
    text-decoration: none;
  }

  .logo-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 42px;
    height: 42px;
    flex-shrink: 0;
  }

  .logo-text {
    font-size: 1.15rem;
    font-weight: 700;
    color: #fff;
    line-height: 1.2;
    white-space: nowrap;
  }

  .logo-sub {
    font-size: 0.65rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    color: var(--gold, #d4a853);
    text-transform: uppercase;
    white-space: nowrap;
  }

  /* ─── Desktop Nav Links ─────────────────────────────────────── */
  .nav-links {
    display: flex;
    align-items: center;
    gap: 0;
    list-style: none;
    margin: 0;
    padding: 0;
    flex: 1;
    justify-content: flex-end;
    flex-wrap: nowrap;
    overflow: hidden;
  }

  .nav-links li {
    flex-shrink: 1;
  }

  .nav-links li a {
    display: block;
    padding: 8px 10px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.83rem;
    font-weight: 400;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    transition: color 0.15s;
    line-height: 1.3;
  }

  .nav-links li a:hover {
    color: #fff;
  }

  /* CTA button */
  .nav-links .nav-cta {
    display: inline-block;
    margin-left: 8px;
    padding: 9px 16px !important;
    background: var(--teal, #0d9488);
    color: #fff !important;
    border-radius: 8px;
    font-weight: 600 !important;
    font-size: 0.82rem !important;
    white-space: nowrap;
    transition: background 0.18s, opacity 0.18s;
  }

  .nav-links .nav-cta:hover {
    background: var(--teal-dark, #0f766e);
    color: #fff !important;
  }

  /* ─── Hamburger (hidden on desktop) ────────────────────────── */
  .hamburger {
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 40px;
    height: 40px;
    background: transparent;
    border: 1.5px solid rgba(255,255,255,0.25);
    border-radius: 8px;
    cursor: pointer;
    flex-shrink: 0;
    padding: 0;
  }

  .hamburger span {
    display: block;
    width: 20px;
    height: 2px;
    background: #fff;
    border-radius: 2px;
    transition: transform 0.2s, opacity 0.2s;
  }

  /* ─── Mobile Nav Drawer ─────────────────────────────────────── */
  .mobile-nav {
    display: none;
    flex-direction: column;
    background: var(--dark, #0f172a);
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease, padding 0.3s ease;
    border-top: 1px solid rgba(255,255,255,0.08);
    position: fixed;
    top: 64px;
    left: 0;
    right: 0;
    z-index: 998;
    box-shadow: 0 8px 24px rgba(0,0,0,0.4);
  }

  .mobile-nav.open {
    max-height: 600px;
    padding: 8px 0 16px;
  }

  .mobile-nav a {
    display: block;
    padding: 13px 24px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.95rem;
    font-weight: 400;
    cursor: pointer;
    text-decoration: none;
    border-bottom: 1px solid rgba(255,255,255,0.05);
    transition: background 0.15s, color 0.15s;
  }

  .mobile-nav a:hover {
    background: rgba(255,255,255,0.05);
    color: #fff;
  }

  .mobile-nav a:last-child {
    border-bottom: none;
  }

  /* ─── Large Desktop (≥ 1440px) ─────────────────────────────── */
  @media (min-width: 1440px) {
    nav {
      padding: 0 48px;
    }
    .nav-links li a {
      font-size: 0.88rem;
      padding: 8px 13px;
    }
    .nav-links .nav-cta {
      padding: 9px 20px !important;
      font-size: 0.88rem !important;
    }
  }

  /* ─── Standard Desktop (1024px – 1439px) ───────────────────── */
  @media (min-width: 1024px) and (max-width: 1439px) {
    nav {
      padding: 0 24px;
    }
    .nav-links li a {
      font-size: 0.82rem;
      padding: 8px 9px;
    }
    .nav-links .nav-cta {
      padding: 8px 14px !important;
      font-size: 0.81rem !important;
      margin-left: 6px;
    }
  }

  /* ─── Laptop / Small Desktop (900px – 1023px) ──────────────── */
  @media (min-width: 900px) and (max-width: 1023px) {
    nav {
      padding: 0 16px;
      gap: 6px;
    }
    .logo-text { font-size: 1rem; }
    .logo-sub  { font-size: 0.6rem; }
    .nav-links li a {
      font-size: 0.76rem;
      padding: 7px 7px;
    }
    .nav-links .nav-cta {
      padding: 7px 11px !important;
      font-size: 0.76rem !important;
      margin-left: 4px;
    }
  }

  /* ─── Tablet (768px – 899px): switch to hamburger ──────────── */
  @media (max-width: 899px) {
    .nav-links  { display: none; }
    .hamburger  { display: flex; }
    .mobile-nav { display: flex; }

    /* ✅ FIXED: bigger navbar + logo on tablet */
    nav {
      height: 76px;
      padding: 0 20px;
    }
    .mobile-nav { top: 76px; }
    .logo-icon {
      width: 54px;
      height: 54px;
    }
    .logo-icon img {
      width: 54px !important;
      height: 54px !important;
      border-radius: 50%;
    }
    .logo-text { font-size: 1.35rem; }
    .logo-sub  { font-size: 0.68rem; letter-spacing: 0.09em; display: block; }
    .nav-logo  { gap: 13px; }
    /* ✅ Hamburger bigger on tablet */
    .hamburger {
      width: 46px;
      height: 46px;
      border-radius: 10px;
    }
    .hamburger span {
      width: 24px;
      height: 2.5px;
    }
  }

  /* ─── Mobile (≤ 480px) ─────────────────────────────────────── */
  @media (max-width: 480px) {
    /* ✅ FIXED: bigger navbar + logo on mobile */
    nav {
      height: 72px;
      padding: 0 16px;
    }
    .mobile-nav { top: 72px; }
    .logo-icon {
      width: 50px;
      height: 50px;
    }
    .logo-icon img {
      width: 50px !important;
      height: 50px !important;
      border-radius: 50%;
    }
    .logo-text { font-size: 1.25rem; }
    .logo-sub  { font-size: 0.62rem; letter-spacing: 0.08em; display: block; }
    .nav-logo  { gap: 12px; }
    /* ✅ Hamburger bigger on mobile */
    .hamburger {
      width: 44px;
      height: 44px;
      border-radius: 9px;
    }
    .hamburger span {
      width: 22px;
      height: 2.5px;
    }
    .mobile-nav a {
      font-size: 0.95rem;
      padding: 13px 16px;
    }
  }
`;

export default function Navbar({ onAdminClick }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { hospital } = useHospital();
  const t = getSpecialtyText(hospital.type);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMobileOpen(false);
  };

  return (
    <>
      <style>{navStyles}</style>

      <nav>
        <a className="nav-logo" onClick={() => scrollTo("home")}>
          <div className="logo-icon">
            {hospital.logoUrl ? (
              <img
                src={hospital.logoUrl}
                alt={hospital.name}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  objectFit: "cover",
                }}
              />
            ) : (
              "🦷"
            )}
          </div>
          <div>
            <div className="logo-text">{hospital.name.split(" ")[0]}</div>
            <div className="logo-sub">{t.navTagline}</div>
          </div>
        </a>

        <ul className="nav-links">
          <li>
            <a onClick={() => scrollTo("services")}>{t.navServices}</a>
          </li>
          <li>
            <a onClick={() => scrollTo("pricing")}>{t.navTreatments}</a>
          </li>
          <li>
            <a onClick={() => scrollTo("about")}>About</a>
          </li>
          <li>
            <a onClick={() => scrollTo("doctors")}>{t.navDoctors}</a>
          </li>
          <li>
            <a onClick={() => scrollTo("testimonials")}>Reviews</a>
          </li>
          <li>
            <a onClick={() => scrollTo("faq")}>FAQ</a>
          </li>
          <li>
            <a
              onClick={onAdminClick}
              style={{ color: "var(--gold)", fontWeight: 500 }}
            >
              Doctor Admin Panel
            </a>
          </li>
          <li>
            <a className="nav-cta" onClick={() => scrollTo("appointment")}>
              {t.navBook}
            </a>
          </li>
        </ul>

        <button
          className="hamburger"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle navigation menu"
        >
          <span />
          <span />
          <span />
        </button>
      </nav>

      <div className={`mobile-nav${mobileOpen ? " open" : ""}`}>
        <a onClick={() => scrollTo("services")}>{t.navServices}</a>
        <a onClick={() => scrollTo("pricing")}>{t.navTreatments}</a>
        <a onClick={() => scrollTo("about")}>About</a>
        <a onClick={() => scrollTo("doctors")}>{t.navDoctors}</a>
        <a onClick={() => scrollTo("gallery")}>Gallery</a>
        <a onClick={() => scrollTo("testimonials")}>Reviews</a>
        <a onClick={() => scrollTo("faq")}>FAQ</a>
        <a
          onClick={() => {
            setMobileOpen(false);
            onAdminClick();
          }}
          style={{ color: "var(--gold)", fontWeight: 500 }}
        >
          Doctor Admin Panel
        </a>
        <a
          onClick={() => scrollTo("appointment")}
          style={{ color: "var(--teal-light)", fontWeight: 500 }}
        >
          {t.navBook} →
        </a>
      </div>
    </>
  );
}
